module.exports = new __parcel__URL__("Burger_Img.d05b1710.png").toString();